<template>
  <div class="container">
    <div
      style="display: flex; justify-content: space-between; align-items: center"
    >
      <div>
        <h1 style="font-size: large; font-weight: 700">Financing</h1>
        <p style="color: #6b7280; font-size: 14px">
          View and manage seller's Financing requests
        </p>
      </div>

      <div style="display: flex; align-items: center; gap: 16px">
        <a-button
          :loading="exportLoading"
          @click="exportExcell"
          style="border-radius: 6px; background: #f9fafb; color: #374151"
          icon="download"
        >
          Export
        </a-button>
        <a-button
          :loading="exportLoading"
          @click="exportExcell"
          style="border-radius: 6px; background: #26a246; color: #ffffff"
          icon="plus"
        >
          New Request
        </a-button>
      </div>
    </div>

    <a-tabs v-model="activeKey" class="green-tabs" style="min-height: 80vh">
      <a-tab-pane key="1" tab="Factoring Requests">
        <div>
          <a-row
            type="flex"
            align="top"
            :gutter="[16, 16]"
            style="margin-top: 30px"
          >
            <a-col style="width: 18%">
              <div
                style="
                  background: #fff;
                  border-radius: 6px;
                  padding: 20px;
                  border: 1px solid #e6e6e6;
                "
              >
                <a-statistic
                  :value-style="{
                    color: '#05004E',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  }"
                  :title-style="{ fontSize: '16px' }"
                  :value="stats.totalRequests"
                >
                  <template #title>
                    <span>Total Requests</span>
                  </template>
                </a-statistic>
              </div>
            </a-col>

            <a-col style="width: 20%">
              <div
                style="
                  background: #fff;
                  border-radius: 6px;
                  padding: 20px;
                  border: 1px solid #e6e6e6;
                "
              >
                <a-statistic
                  :value-style="{
                    color: '#05004E',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  }"
                  :title-style="{ fontSize: '16px' }"
                  :value="stats.approvedRequests"
                >
                  <template #title>
                    <span>Approved Requests</span>
                  </template>
                </a-statistic>
              </div>
            </a-col>

            <a-col style="width: 20%">
              <div
                style="
                  background: #fff;
                  border-radius: 6px;
                  padding: 20px;
                  border: 1px solid #e6e6e6;
                "
              >
                <a-statistic
                  :value-style="{
                    color: '#05004E',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  }"
                  :title-style="{ fontSize: '16px' }"
                  :value="formatAmount(stats.totalFinanced)"
                  
                >
                  <template #title>
                    <span>Total Financed</span>
                  </template>
                </a-statistic>
              </div>
            </a-col>
            <a-col style="width: 23%">
              <div
                style="
                  background: #fff;
                  border-radius: 6px;
                  padding: 20px;
                  border: 1px solid #e6e6e6;
                "
              >
                <a-statistic
                  :value-style="{
                    color: '#05004E',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  }"
                  :title-style="{ fontSize: '16px' }"
                  :value="formatAmount(stats.outstandingRepayment)"
                
                >
                  <template #title>
                    <span>Outstanding Repayment</span>
                  </template>
                </a-statistic>
              </div>
            </a-col>
            <a-col style="width: 19%">
              <div
                style="
                  background: #fff;
                  border-radius: 6px;
                  padding: 20px;
                  border: 1px solid #e6e6e6;
                "
              >
                <a-statistic
                  :value-style="{
                    color: '#05004E',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  }"
                  :title-style="{ fontSize: '16px' }"
                  :value="stats.avgFinancingFee.toFixed(2)"
                  :suffix="`%`"
                >
                  <template #title>
                    <span>Avg. Financing Fee</span>
                  </template>
                </a-statistic>
              </div>
            </a-col>
          </a-row>

          <div>
            <!-- Filters -->
            <a-row :gutter="16" class="mb-4 mt-5">
              <a-col :span="4">
                <a-label>Search by Invoice</a-label>
                <a-input
                  v-model="searchInvoice"
                  placeholder="Search by Invoice ID"
                  allowClear
                />
              </a-col>

              <a-col :span="5">
                <a-label>Status</a-label>
                <a-select
                  v-model="filters.status"
                  placeholder="All Status"
                  allowClear
                  style="width: 100%"
                >
                  <a-select-option
                    v-for="s in statusOptions"
                    :key="s"
                    :value="s"
                  >
                    {{ s }}
                  </a-select-option>
                </a-select>
              </a-col>


              <a-col :span="5">
                <a-label>Repayment Status</a-label>
                <a-select
                  v-model="filters.repaymentStatus"
                  placeholder="All Repayment Status"
                  allowClear
                  style="width: 100%"
                >
                  <a-select-option
                    v-for="r in repaymentStatusOptions"
                    :key="r"
                    :value="r"
                  >
                    {{ r }}
                  </a-select-option>
                </a-select>
              </a-col>

              <a-col :span="5">
                <a-label>Date Range</a-label>
                <a-range-picker
                  v-model="filters.dateRange"
                  style="width: 100%"
                />
              </a-col>
            </a-row>

            <!-- Table -->
            <a-table
              :columns="columns"
              :data-source="applications"
              row-key="id"
              :scroll="{ x: 'max-content' }"
              :pagination="tablePagination"
            >
              <template slot="actions" slot-scope=" text, record ">
                <a-dropdown>
                  <a-button type="link" style="color: #9ca3af">
                    <i class="fa fa-ellipsis-v"></i>
                  </a-button>
                  <a-menu slot="overlay">
                    <a-menu-item key="view-details" @click="goToView(record)">
                      <i class="fa fa-eye" style="margin-right: 8px"></i>
                      View Details
                    </a-menu-item>
                    <a-menu-item key="view-disbursements" @click="viewDisbursements(record)">
                      <i class="fa fa-money-bill-wave" style="margin-right: 8px"></i>
                      View Disbursements
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </template>

              <!-- Status column now uses StatusTag via customRender -->
            </a-table>
          </div>
        </div>
      </a-tab-pane>
      <!-- <a-tab-pane key="2" tab="Credit History"
        >/* Financing content goes here */</a-tab-pane
      > -->
    </a-tabs>

    <InvoiceFactoringRequest
      :visible="invoiceModalVisible"
      :requestData="selectedRequest"
      @ok="handleInvoiceDecision"
      @close="invoiceModalVisible = false"
    />

    <!-- Invoice Disbursement Details Drawer -->
    <InvoiceDisbursementDetailsDrawer
      :visible="showDisbursementDetailsDrawer"
      :invoiceData="selectedDisbursement && selectedDisbursement.invoiceData"
      @close="showDisbursementDetailsDrawer = false"
    />
  </div>
</template>

<script>
import moment from "moment";
import sellersService from "../../api/sellers.service";
import InvoiceFactoringRequest from "./InvoiceFactoringRequest.vue";
import InvoiceDisbursementDetailsDrawer from "../financing/InvoiceDisbursementDetailsDrawer.vue";
import { formatAmount, formatDate } from "../../utils/index.js";
// eslint-disable-next-line
import StatusTag from "../shared-components/StatusTag.vue";

export default {
  name: "Financing",
  components: {
    InvoiceFactoringRequest,
    InvoiceDisbursementDetailsDrawer,
    // eslint-disable-next-line
    StatusTag
  },
  props: {
    sellerId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeKey: "1",
      searchInvoice: "",
      searchDebounceTimeout: null,
      filters: {
        status: undefined,
        repaymentStatus: undefined,
        dateRange: null,
      },
      pagination: {
        pageIndex: 1,
        pageSize: 10,
        totalCount: 0,
      },
      loading: false,
      statusOptions: ["Approved", "Pending", "Rejected"],
      repaymentStatusOptions: ["Settled", "Unsettled"],
      columns: [
        {
          title: "Request ID",
          dataIndex: "id",
          key: "id",
        },
        { 
          title: "Buyer", 
          dataIndex: "invoiceResponse.customerBusinessName", 
          key: "buyerName" 
        },
        {
          title: "Invoice Number",
          dataIndex: "invoiceid",
          key: "invoiceNumber",
          customRender: (text, record) => (
            <a-button type="link" onClick={() => this.goToView(record)}>
              {text}
            </a-button>
          )
        },
        {
          title: "Invoice Value",
          dataIndex: "invoiceResponse.totalOrderValue",
          key: "invoiceValue",
          customRender: (text) => formatAmount(text)
        },
        {
          title: "Requested Amount",
          dataIndex: "advanceamount",
          key: "requestedAmount",
          customRender: (text) => formatAmount(text)
        },
        {
          title: "Status",
          key: "status",
          dataIndex: "status",
          customRender: (text) => ({
            children: [this.$createElement('StatusTag', { props: { status: text } })]
          })
        },
        {
          title: "Created At",
          dataIndex: "dateapplied",
          key: "createdAt",
          customRender: (text) => formatDate(text)
        },
        {
          title: "Actions",
          key: "actions",
          scopedSlots: { customRender: "actions" },
        },
      ],
      applications: [],
      stats: {
        totalRequests: 0,
        approvedRequests: 0,
        totalFinanced: 0,
        outstandingRepayment: 0,
        avgFinancingFee: 0
      },
      invoiceModalVisible: false,
      selectedRequest: null,
      showDisbursementDetailsDrawer: false,
      selectedDisbursement: null,
    };
  },
  computed: {
    filteredApplications() {
      // Filtering is now handled server-side, but keep this for client-side search if needed
      return this.applications.filter((app) => {
        const matchesSearch =
          !this.searchInvoice ||
          app.invoiceid
            .toLowerCase()
            .includes(this.searchInvoice.toLowerCase());

        const matchesStatus =
          !this.filters.status || app.status === this.filters.status;


        const matchesDateRange =
          !this.filters.dateRange ||
          (moment(app.dateapplied).isSameOrAfter(
            this.filters.dateRange[0],
            "day"
          ) &&
            moment(app.dateapplied).isSameOrBefore(
              this.filters.dateRange[1],
              "day"
            ));

        return (
          matchesSearch &&
          matchesStatus &&
          matchesDateRange
        );
      });
    },
    tablePagination() {
      return {
        current: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
        total: this.pagination.totalCount,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} requests`,
        showSizeChanger: false,
      };
    },
  },
  watch: {
    sellerId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.pagination.pageIndex = 1;
          this.fetchFactoringApplications();
        }
      }
    },
    'pagination.pageIndex'() {
      this.fetchFactoringApplications();
    },
    searchInvoice() {
      if (this.searchDebounceTimeout) clearTimeout(this.searchDebounceTimeout);
      this.searchDebounceTimeout = setTimeout(() => {
        this.pagination.pageIndex = 1;
        this.fetchFactoringApplications();
      }, 400);
    },
    filters: {
      handler() {
        this.pagination.pageIndex = 1;
        this.fetchFactoringApplications();
      },
      deep: true,
    },
  },
  created() {
    this.fetchFactoringApplications();
  },
  methods: {
    formatAmount,
    async fetchFactoringApplications() {

        this.loading = true;
        const params = {
          pageIndex: this.pagination.pageIndex,
          pageSize: this.pagination.pageSize,
          status: this.filters.status,
          repaymentStatus: this.filters.repaymentStatus,
          dateFrom: this.filters.dateRange ? this.filters.dateRange[0] : undefined,
          dateTo: this.filters.dateRange ? this.filters.dateRange[1] : undefined,
          invoiceId: this.searchInvoice,
        };
        const response = await sellersService.getSellerFactoringApplications(this.sellerId, params);
        // console.log(this.sellerId)
        if (response.data?.data?.results) {
          const data = response.data.data;
          this.applications = data.results;
          this.pagination.totalCount = data.totalCount || 0;
          this.pagination.pageIndex = data.pageIndex || this.pagination.pageIndex;
          // Calculate statistics
          this.stats = {
            totalRequests: data.totalCount || this.applications.length,
            approvedRequests: this.applications.filter(app => app.status === 'Approved').length,
            totalFinanced: this.applications.reduce((sum, app) => sum + (app.advanceamount || 0), 0),
            outstandingRepayment: this.applications
              .filter(app => app.status === 'Approved')
              .reduce((sum, app) => sum + (app.totalrepaymentamount || 0), 0),
            avgFinancingFee: this.applications.reduce((sum, app) => sum + (app.feestructure || 0), 0) / (this.applications.length || 1)
          };
        } else {
          this.applications = [];
          this.pagination.totalCount = 0;
          this.stats = {
            totalRequests: 0,
            approvedRequests: 0,
            totalFinanced: 0,
            outstandingRepayment: 0,
            avgFinancingFee: 0
          };
          this.$message.error("Error fetching factoring applications")
        }
        this.loading = false;
      },
    getStatusText(status) {
      const statusMap = {
        0: "Pending",
        1: "Approved",
        2: "Rejected",
        3: "Suspended"
      };
      return statusMap[status] || "Unknown";
    },
    goToView(record) {
      console.log('Record in goToView:', record); // Debug log
      const invoiceId = record.invoiceid || record.invoiceNumber || record.invoice_number;
      if (!invoiceId) {
        this.$message.error('Invoice number not found');
        return;
      }
      this.$router.push({
        path: `/sellers/${this.sellerId}/factoring/${invoiceId}`
      });
    },
    viewDisbursements(record) {
      console.log('Record in viewDisbursements:', record); // Debug log
      
      // Extract invoice data from the factoring application record
      const invoiceResponse = record.invoiceResponse;
      if (!invoiceResponse) {
        this.$message.error('Invoice data not found');
        return;
      }

      // Set invoice data for the drawer - only essential properties
      this.selectedDisbursement = {
        invoiceData: {
          id: invoiceResponse.id,
          customerBusinessName: invoiceResponse.customerBusinessName,
          sellerName: invoiceResponse.sellerName || record.createdby,
          amountPayable: invoiceResponse.amountPayable,
          totalDisbursed: invoiceResponse.totalDisbursed,
          disbursementStatus: invoiceResponse.disbursementStatus,
          createdAt: invoiceResponse.createdAt,
        }
      };
      
      this.showDisbursementDetailsDrawer = true;
    },
    handleInvoiceDecision(data) {
      console.log('Invoice decision:', data);
      // Handle the decision data here
      this.invoiceModalVisible = false;
      // Optionally refresh the applications list
      this.fetchFactoringApplications();
    }
  },
};
</script>

<style scoped>
.container {
  margin-top: 60px;
}

.status-tag {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  display: inline-block;
}

.status-approved {
  background-color: #87d068;
  color: white;
}

.status-pending {
  background-color: #faad14;
  color: white;
}

.status-rejected {
  background-color: #ff4d4f;
  color: white;
}
</style>
